import { Link } from 'react-router-dom';

export default function MyLink({ children, sx, ...props }) {
  return (
    <Link {...props} style={{ textDecoration: 'none', color: 'inherit', ...sx }}>
      {children}
    </Link>
  );
}
